import { useSyncStore } from '@/store/sync'

export function SyncBanner() {
  const { isSyncing, syncComplete, dismissSync } = useSyncStore()
  if (!isSyncing && !syncComplete) return null

  return (
    <div className="cg-sync-banner" data-complete={syncComplete || undefined}>
      {isSyncing && (
        <>
          <span className="cg-spinner" style={{ width: 14, height: 14, flexShrink: 0 }} aria-hidden="true" />
          <span>We&apos;re analyzing your account for first-time setup, data may be incomplete</span>
        </>
      )}
      {syncComplete && (
        <>
          <span className="cg-sync-check" aria-hidden="true">✓</span>
          <span>Setup complete!</span>
          <button className="cg-btn ghost tiny" onClick={dismissSync} style={{ marginLeft: 'auto' }}>
            Dismiss
          </button>
        </>
      )}
    </div>
  )
}
